import React from 'react';
import './PdfConversion.scss';
import ConversionIcon from '../../assets/ConversionIcon.png';
import PdfToImage from '../../assets/PdfToImage.png';
import PdfToLong from '../../assets/PdfToLong.png';
import PdfToPpt from '../../assets/PdfToPpt.png';
import PdfToWord from '../../assets/PdfToWord.png';
import PdfToExcel from '../../assets/PdfToExcel.png';
import ImageToPdf from '../../assets/ImageToPdf.png';
import PptToPdf from '../../assets/PptToPdf.png';
import ExcelToPdf from '../../assets/ExcelToPdf.png';
import WordToPdf from '../../assets/WordToPdf.png';
import WebpageToPdf from '../../assets/WebpageToPdf.png';
import TextToPdf from '../../assets/TextToPdf.png';


export default function PdfConversion() {
  return (
    <div className='conversion-container'>
      <div className='heading-container'>
        <h2>Seamless PDF Conversion for Every Need</h2>
        <div className='conversion-icon-container'>
          <img src={ConversionIcon} alt="convert pdf" />
        </div>
      </div>
      <div className='info-container'>
        <div className='column1'>
          <h3>Convert from Pdf</h3>
          <div className='row1'>
            <div className='compress-pdf-container'>
              <div className='compress-icon-container'>
                <img src={PdfToImage} alt="PdfToImage" />
              </div>
              <p>PDF to</p>
              <p>Image</p>
            </div>
            <div className='webp-container'>
              <div className='webp-icon-container'>
                <img src={PdfToLong} alt="PdfToLong" />
              </div>
              <p>PDF to</p>
              <p>Long Image</p>
            </div>
            <div className='webp-container'>
              <div className='webp-icon-container'>
                <img src={PdfToPpt} alt="PdfToPpt" />
              </div>
              <p>PDF to</p>
              <p>PPT</p>
            </div>
          </div>
          <div className='row2'>
            <div className='jpg-container'>
              <div className='jpg-icon-container'>
                <img src={PdfToWord} alt="PdfToWord" />
              </div>
              <p>PDF to</p>
              <p>Word</p>
            </div>
            <div className='png-container'>
              <div className='png-icon-container'>
                <img src={PdfToExcel} alt="PdfToExcel" />
              </div>
              <p>PDF to</p>
              <p>Excel</p>
            </div>
          </div>
        </div>

        <div className="divider" />

        <div className='column2'>
          <h3>Convert to Pdf</h3>
          <div className='row1'>
            <div className='compress-pdf-container'>
              <div className='compress-icon-container'>
                <img src={ImageToPdf} alt="ImageToPdf" />
              </div>
              <p>Image to</p>
              <p>PDF</p>
            </div>
            <div className='webp-container'>
              <div className='webp-icon-container'>
                <img src={PptToPdf} alt="PptToPdf" />
              </div>
              <p>PPT to</p>
              <p>PDF</p>
            </div>
            <div className='webp-container'>
              <div className='webp-icon-container'>
                <img src={ExcelToPdf} alt="ExcelToPdf" />
              </div>
              <p>Excel to</p>
              <p>PDF</p>
            </div>
          </div>
          <div className='row2'>
            <div className='jpg-container'>
              <div className='jpg-icon-container'>
                <img src={WordToPdf} alt="WordToPdf" />
              </div>
              <p>Word to</p>
              <p>PDF</p>
            </div>
            <div className='png-container'>
              <div className='png-icon-container'>
                <img src={WebpageToPdf} alt="WebpageToPdf" />
              </div>
              <p>Webpage to</p>
              <p>PDF</p>
            </div>
            <div className='resize-pdf-container'>
              <div className='resize-icon-container'>
                <img src={TextToPdf} alt="TextToPdf" />
              </div>
              <p>Text to</p>
              <p>PDF</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
